import { render, staticRenderFns } from "./ConfigTabHonors.vue?vue&type=template&id=447b863d"
import script from "./ConfigTabHonors.vue?vue&type=script&lang=js"
export * from "./ConfigTabHonors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports